import React from "react";
import { useState, useContext, useRef } from 'react';
import { Link } from 'react-router-dom';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
import { AgGridReact } from 'ag-grid-react'; 
import { AG_GRID_LOCALE_RU } from './common/AgGrid/locale.ru';

import { GetSignStatus, GetApproveStatus } from './Order';
import SearchBar from "./common/SearchBar";
import Loader from "./common/Loader";

import axios_api from './../Api';
import { API_URL, AUTH_TOKEN } from './../Context';
import {
  downloadOrdersXlsx,
  getOrderExportHeaders,
  getOrderExportRowsFromGrid,
  getOrdersCountText,
} from '../utils/ordersExport';


ModuleRegistry.registerModules([AllCommunityModule]);


export default function OrderList({}) {

  const [orders, setOrders] = useState([]);
  const [availableYears, setAvailableYears] = useState([]);

  // ФИЛЬТР ПО ЗНАЧЕНИЯМ
  /*
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedApproveStatuses, setSelectedApproveStatuses] = useState(new Set());
  const [availableApproveStatuses, setAvailableApproveStatuses] = useState([]);
  const [showStatusFilter, setShowStatusFilter] = useState(false);
  */

  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);

  const [loading, setLoading] = useState(true);
  //const [searchText, setSearchText] = useState('');
  const [selectedYear, setSelectedYear] = useState(null);
  const [displayedCount, setDisplayedCount] = useState(null);
  const gridApiRef = useRef(null);

  function syncDisplayedCount(api) {
    if (!api || typeof api.getDisplayedRowCount !== 'function') {
      return;
    }
    setDisplayedCount(api.getDisplayedRowCount());
  }

  function HandleExportXlsx() {
    const api = gridApiRef.current;
    const headers = getOrderExportHeaders(colDefs);
    const rows = getOrderExportRowsFromGrid(api, colDefs);
    downloadOrdersXlsx(headers, rows);
  }




  const LinkCellRenderer = function(params) {
    const url = 'order/' + params.data.id || `#`; // Fallback URL
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {params.data.user.username}
      </a>
    );
  }

  const ApproveStatusCellRenderer = function(params) {
    const approveStatus = params.data?.approve_status;
    const displayText = GetApproveStatus(approveStatus);
    
    if (approveStatus === "APPROVED") {
      return <span className="text-success fw-semibold">{displayText}</span>;
    } else if (approveStatus === "REJECTED") {
      return <span className="text-danger fw-semibold">{displayText}</span>;
    } else if (approveStatus === "APPROVED_DOCS_REJECTED") {
      return <span className="text-danger">{displayText}</span>;
    }
    return <span>{displayText}</span>;
  }

  const UserDocsCellRenderer = function(params) {
    const hasDocs = params.data?.user_signed_contract_pdf && params.data?.user_signed_order_form_pdf;
    
    if (hasDocs) {
      return <span className="text-primary">Да</span>;
    }
    return <span>Нет</span>;
  }

  const SignStatusCellRenderer = function(params) {
    const signStatus = params.data?.sign_status;
    const displayText = GetSignStatus(signStatus);
    
    if (signStatus === "NOT_SIGNED") {
      return <span>{displayText}</span>;
    } else if (signStatus === "SELLER_SIGNED" || signStatus === "CLIENT_SIGNED") {
      return <span className="text-success">{displayText}</span>;
    } else if (signStatus === "BOTH_SIGNED") {
      return <span className="text-success fw-semibold">{displayText}</span>;
    }
    return <span>{displayText}</span>;
  }

  const MultiplePositionsCellRenderer = function(params) {
    const hasMultiple = params.data?.multiple_positions;
    
    if (hasMultiple) {
      return <span className="text-primary">Да</span>;
    }
    return <span>Нет</span>;
  }

  const [colDefs, setColDefs] = useState([
    { field: "user", "headerName": "лаборатория", flex: 1.2,
      cellRenderer: LinkCellRenderer,
      valueGetter: (params) => params.data?.user?.username || '',
      filterValueGetter: (params) => params.data?.user?.username || ''
    },
    { field: "year", "headerName": "год договора", flex: 1.2, },
    { field: "date_created", "headerName": "создан",flex: 1, },
    { field: "approve_status", "headerName": "статус утверждения",  flex: 2.2,
      cellRenderer: ApproveStatusCellRenderer,
      valueGetter: (params) => GetApproveStatus(params.data?.approve_status),
    },
    { field: "user_docs", "headerName": "документы пользователя", flex: 2,
      cellRenderer: UserDocsCellRenderer,
      valueGetter: (params) => (params.data?.user_signed_contract_pdf && params.data?.user_signed_order_form_pdf ? 'Да' : 'Нет'),
    },  
    { field: "sign_status", "headerName": "статус подписания",  flex: 2, 
      cellRenderer: SignStatusCellRenderer,
      valueGetter: (params) => GetSignStatus(params.data?.sign_status),
    },  
    { field: "multiple_positions", "headerName": "множественные позиции", flex: 2,
      cellRenderer: MultiplePositionsCellRenderer,
      valueGetter: (params) => (params.data?.multiple_positions ? 'Да' : 'Нет'),
    },      

  ]);


  // Загрузка списка доступных годов
  React.useEffect(() => {
    axios_api.get(api_url + '/orders_years/', {
      headers: {"Authorization": token}
    })
    .then((result) => {
      const years = result.data.years;
      setAvailableYears(years);
      
      // Проверяем сохраненный год в localStorage
      const savedYear = localStorage.getItem('selectedYear');
      if (savedYear && years.includes(parseInt(savedYear))) {
        // Используем сохраненный год, если он есть в списке доступных
        setSelectedYear(parseInt(savedYear));
      } else if (years.length > 0) {
        // Иначе используем первый год из списка
        setSelectedYear(years[0]);
      }
    })
    .catch((error) => {
      console.error('Ошибка загрузки списка годов:', error);
    });
  }, [api_url, token]);


  // Сохранение выбранного года в localStorage
  React.useEffect(() => {
    if (selectedYear !== null) {
      localStorage.setItem('selectedYear', selectedYear);
    }
  }, [selectedYear]);

  // Загрузка заказов для выбранного года
  React.useEffect(() => {
    if (selectedYear === null) {
      return; // Ждем, пока год не будет установлен
    }

    setLoading(true);
    let orders = axios_api.get(api_url + '/orders/', {
      headers: {"Authorization": token},
      params: {"year": selectedYear}
    });

    orders.then(
      (result) => {
        let apiReturnedOrder = result.data;
        setOrders(apiReturnedOrder);
        setDisplayedCount(null);
        gridApiRef.current = null;
        setLoading(false);
        
        // ФИЛЬТР ПО ЗНАЧЕНИЯМ
        /*
        // Получаем уникальные статусы
        const statuses = new Set();
        apiReturnedOrder.forEach(order => {
          if (order.approve_status) {
            statuses.add(order.approve_status);
          }
        });
        const statusesArray = Array.from(statuses).map(raw => ({
          raw,
          display: GetApproveStatus(raw)
        })).sort((a, b) => a.display.localeCompare(b.display));
        setAvailableApproveStatuses(statusesArray);
        */
      },
      (error) => {
        console.log(error)
        setOrders([]);
        setDisplayedCount(0);
        gridApiRef.current = null;
        setLoading(false);
      }
    );
  }, [selectedYear, api_url, token]);


  // ФИЛЬТР ПО ЗНАЧЕНИЯМ
  /*
  // Фильтрация данных
  React.useEffect(() => {
    if (selectedApproveStatuses.size === 0) {
      setFilteredOrders(orders);
    } else {
      const filtered = orders.filter(order => 
        selectedApproveStatuses.has(order.approve_status)
      );
      setFilteredOrders(filtered);
    }
  }, [orders, selectedApproveStatuses]);

  // Закрытие фильтра при клике вне его области
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (showStatusFilter && !event.target.closest('.status-filter-container')) {
        setShowStatusFilter(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showStatusFilter]);
  */


  return ( loading ? 
    (
      <Loader/>
    ) : (

      <>
        <div className="row">
          <h3 className="m-3">Заказы и Договоры</h3>
        </div>

        <div className="m-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div className="d-inline-flex gap-2 align-items-center">
            <label className="mb-0">год:</label>
            <select
              className="form-select"
              aria-label="example"
              value={selectedYear || ''}
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              style={{ width: 'auto' }}
              disabled={availableYears.length === 0}
            >
              {availableYears.map(year => (<option key={year} value={year}>{year}</option>))}
            </select>
          </div>
          <div className="d-flex align-items-center gap-3">
            {selectedYear !== null && (
              <small>
                {getOrdersCountText({
                  year: selectedYear,
                  total: orders.length,
                  displayed: displayedCount == null ? orders.length : displayedCount,
                })}
              </small>
            )}
            <button
              type="button"
              className="btn lk-button"
              onClick={HandleExportXlsx}
            >
              выгрузить в XLSX
            </button>
          </div>
        </div>

        <div className="m-3 mb-5">
          <AgGridReact
            rowData={orders}
            /* ФИЛЬТР ПО ЗНАЧЕНИЯМ
            rowData={filteredOrders}
            */
            columnDefs={colDefs}
            domLayout='autoHeight'
            defaultColDef={{
              sortable: true,
              filter: true,
              resizable: true
            }}
            onGridReady={(params) => {
              gridApiRef.current = params.api;
              syncDisplayedCount(params.api);
            }}
            onFilterChanged={(params) => {
              syncDisplayedCount(params.api);
            }}
            onModelUpdated={(params) => {
              syncDisplayedCount(params.api);
            }}
            getRowStyle={(params) => {
              if (params.data?.viewed === false) {
                return {
                  backgroundColor: '#f0fff4ff',
                  fontWeight: 'bold'
                };
              }
              return null;
            }}
            localeText={AG_GRID_LOCALE_RU}
          />
        </div>
      </>
    )  
  );


}
